import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import "aos/dist/aos.css";
import { motion } from "framer-motion";

function Love() {
  return (
    <Section>
      <Container>
        <>
          <Head>
            <Span
              initial={{ opacity: 0, y: "100%" }}
              whileInView={{ opacity: 1, y: "0%" }}
              transition={{ delay: 1 }}
              viewport={{ once: true }}
            >
              Built with intention.
            </Span>
            <RevealBar
              initial={{
                width: "0%",
                top: 0,
                height: "100%",
                position: "absolute",
              }}
              whileInView={{ width: "100%", transform: "translateX(100%)" }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
            />
          </Head>
          <PWrapper>
            <P
              initial={{ y: "30px" }}
              whileInView={{ y: "0px" }}
              transition={{ duration: 0.5 }}
            >
              A curated selection of projects I've crafted from concept to
              launch.
            </P>
          </PWrapper>
        </>
      </Container>
    </Section>
  );
}

export default Love;

const Section = styled.div`
  height: 420px;
  background-color: var(--bg-alt);
  color: var(--text);
  display: flex;
  align-items: center;
  justify-content: start;
  border-top: 1px solid var(--border);
  transition: background-color 0.3s ease, color 0.3s ease;

  @media (max-width: 768px) {
    height: auto;
    padding: 48px 0;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: auto;
  padding: 0 20px;

  @media (max-width: 1430px) {
    padding: 0 30px;
  }
`;

const Head = styled(motion.h1)`
  overflow: hidden;
  position: relative;
  width: fit-content;
  font-size: 48px;
  line-height: 56px;
  margin-bottom: 10px;
  letter-spacing: -1px;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 40px;
  }
`;

const Span = styled(motion.span)``;

const PWrapper = styled.div`
  overflow: hidden;
  margin-top: 60px;

  @media (max-width: 768px) {
    margin-top: 30px;
  }
`;

const P = styled(motion.p)`
  position: relative;
  width: fit-content;
  font-size: 17px;
  line-height: 26px;
  margin-bottom: 10px;
  color: var(--text-4);
  font-weight: 300;
  letter-spacing: 0.2px;

  @media (max-width: 768px) {
    width: 100%;
    font-size: 15px;
  }
`;

const RevealBar = styled(motion.div)`
  background: var(--overlay);
  transition: background 0.3s ease;
`;
